import { Routes, Route } from 'react-router-dom'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { ErrorBoundary } from '@/components/error'
import { LoginPage } from '@/pages/login/LoginPage'
import { DashboardPage } from '@/pages/dashboard/DashboardPage'
import { MoveArchivePage } from '@/pages/move-archive/MoveArchivePage'
import { MoveDetailPage } from '@/pages/move-detail/MoveDetailPage'
import { CreateMovePage } from '@/pages/create-move/CreateMovePage'
import { SeriesArchivePage } from '@/pages/series-archive/SeriesArchivePage'
import { SeriesDetailPage } from '@/pages/series-detail/SeriesDetailPage'
import { SeriesGraphEmbedPage } from '@/pages/series-detail/SeriesGraphEmbedPage'
import { CreateSeriesPage } from '@/pages/create-series/CreateSeriesPage'
import { TagManagementPage } from '@/pages/tag-management/TagManagementPage'
import { CreateTagPage } from '@/pages/create-tag/CreateTagPage'
import { TagDetailPage } from '@/pages/tag-detail/TagDetailPage'
import { AccountPage } from '@/pages/account/AccountPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { TermsOfServicePage } from '@/pages/TermsOfServicePage'
import { PrivacyPolicyPage } from '@/pages/PrivacyPolicyPage'

export function AppRoutes() {
  return (
    <Routes>
      {/* Home page is now the login page - UNPROTECTED */}
      <Route path="/" element={<LoginPage />} />

      {/* Legal pages - UNPROTECTED */}
      <Route path="/terms" element={<TermsOfServicePage />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />

      {/* Main app pages - PROTECTED */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <ErrorBoundary level="page">
              <DashboardPage />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />

      {/* Account page - PROTECTED */}
      <Route
        path="/account"
        element={
          <ProtectedRoute>
            <ErrorBoundary level="page">
              <AccountPage />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />

      {/* Move-related pages - PROTECTED */}
      <Route
        path="/moves"
        element={
          <ProtectedRoute>
            <ErrorBoundary level="page">
              <MoveArchivePage />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/moves/new"
        element={
          <ProtectedRoute>
            <ErrorBoundary level="page">
              <CreateMovePage />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/moves/:id"
        element={
          <ProtectedRoute>
            <ErrorBoundary level="page">
              <MoveDetailPage />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />

      {/* Series-related pages - PROTECTED */}
      <Route
        path="/series"
        element={
          <ProtectedRoute>
            <ErrorBoundary level="page">
              <SeriesArchivePage />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/series/new"
        element={
          <ProtectedRoute>
            <ErrorBoundary level="page">
              <CreateSeriesPage />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/series/:id"
        element={
          <ProtectedRoute>
            <ErrorBoundary level="page">
              <SeriesDetailPage />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />

      {/* Tag-related pages - PROTECTED */}
      <Route
        path="/tags"
        element={
          <ProtectedRoute>
            <ErrorBoundary level="page">
              <TagManagementPage />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tags/new"
        element={
          <ProtectedRoute>
            <ErrorBoundary level="page">
              <CreateTagPage />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tags/:id"
        element={
          <ProtectedRoute>
            <ErrorBoundary level="page">
              <TagDetailPage />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />

      {/* Series graph embed — UNPROTECTED (auth via the native bridge: token delivered over setToken after the bridgeReady handshake) */}
      <Route
        path="/series/:id/graph"
        element={
          <ErrorBoundary level="page">
            <SeriesGraphEmbedPage />
          </ErrorBoundary>
        }
      />

      {/* 404 page - UNPROTECTED */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
